import { useState } from "react";

const Tile = ({ size }) => (
  <div
    className={`${size} rounded-xl flex items-center justify-center font-display font-black text-black`}
    style={{ background: "linear-gradient(180deg, #FFC107, #D97706)" }}
    data-testid="logo-fallback"
  >
    F
  </div>
);

export const Logo = ({ size = "w-11 h-11 text-lg" }) => {
  const [failed, setFailed] = useState(false);
  if (failed) return <Tile size={size} />;
  return (
    <img
      src="/logo.png"
      alt="FMI Casino"
      onError={() => setFailed(true)}
      className={`${size} rounded-full object-contain drop-shadow-[0_0_12px_rgba(255,193,7,0.35)]`}
      data-testid="logo-image"
    />
  );
};
